import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import useHawksearchComponent from './useHawksearchComponent';
import { useUserReceived } from '../hooks/useUserData';
import { fetchHawksearchResultsUsingUrl } from './actions';
import { isSupportTabUrl } from './util';

/**
 * This hook is only used in the SearchPageContainer component.
 * A HawkSearch API call is made whenever the query string changes.
 * The following user interactions trigger an API call by modiying the query string:
 * 1. Selecting/unselecting a filter
 * 2. Changing tabs which cahnges
 * 3. Sorting
 * 4. Selecting a category
 */
export default () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { search } = location || {};
    const hawksearchResults = useHawksearchComponent();
    const { query } = hawksearchResults || {};
    const vanityUrl = useSelector(state => state && state.slugInfo && state.slugInfo.vanityUrl);

    const userReceived = useUserReceived();
    useEffect(() => {
        // TODO: Check if there's a better way to prevent RECEIVE_SLUG_INFO action from overwriting hawksearchResults in pstores. 
        // vanityUrl check is needed for pstores only
        if(userReceived && search !== query && !isSupportTabUrl(search) && typeof vanityUrl === 'string' && /^\/?sitesearch/i.test(vanityUrl)){
            //fetchHawksearch
            let options = {
                query: search,
                type: /(\?|^|\&)type\=content($|\&)/i.test(search) ? 'content' : 'products'
            }
            dispatch(fetchHawksearchResultsUsingUrl(options))
        }
    }, [search, !!userReceived, vanityUrl]);
}